import React, {useEffect, useState} from 'react'
import RoundedCheckbox from "../RoundedCheckbox";
import { connect, useDispatch } from "react-redux";
import { isCompanyAdmin, isCompanyUser } from "../../modules/permissions";
let VenuesToExport = ({
                        rfp,
                        setVenuesSelected,
                        venuesSelected,
  isCompany
                      }) => {
  const [showMinWarning, setShowMinWarning] = useState(false);
  useEffect(() => {
    let venues = {};
    rfp.enquiry_venue_datas.map(evd => {
      venues[evd.venue.name] = {
        selected: true,
        isNotIncluded: evd.status === 0 || (isCompany && !evd.is_visible_to_client),
        id: evd.venue.id
      };
    });
    setVenuesSelected(venues);
  }, []);

  if(Object.keys(venuesSelected).length === 0)
  {
    return <></>
  }
  return (
    <div className={'overflow-auto mr-4'} style={{height: '250px'}}>
      <div className="pb-2">
        <h3>Venues To Export</h3>
        {showMinWarning && (
          <p className="text-red text-sm mt-1">You must select at least one venue.</p>
        )}
      </div>
      {rfp.enquiry_venue_datas.map(evd => {
        if(venuesSelected[evd.venue.name].isNotIncluded) {
          return;
        }
        return <div
          className={`pointer`}
          onClick={() => {
            const isCurrentlySelected = venuesSelected[evd.venue.name].selected;
            if (isCurrentlySelected) {
              const selectedCount = Object.values(venuesSelected).filter(vs => vs.selected && !vs.isNotIncluded).length;
              if (selectedCount <= 1) {
                setShowMinWarning(true);
                return;
              }
            }
            setShowMinWarning(false);
            setVenuesSelected({...venuesSelected, [evd.venue.name]: {
              selected: !isCurrentlySelected,
              id: venuesSelected[evd.venue.name].id
              }})
          }}
        >
            <input
              type="checkbox"
              checked={venuesSelected[evd.venue.name].selected}
              className={'mr-2'}
            />{" "}
            <span
              className={`font-heading text-sm  ${
                venuesSelected[evd.venue.name].selected ? "text-black" : "text-grey-darker"
              } font-bold mr-3 xl:mr-2 xxl:mr-3`}
            >
                    {evd.venue.name}
            </span>
        </div>
      })}
      {venuesSelected && Object.values(venuesSelected).filter(vs => vs.isNotIncluded).length > 0 ?
      <div>
        <hr className={'my-1 border-black'}/>
        {rfp.enquiry_venue_datas.map(evd => {
          if(!venuesSelected[evd.venue.name].isNotIncluded) {
            return;
          }
          return <div
            title={'Not available to export - Awaiting proposal'}
            className={``}
            onClick={() => {

            }}
          >
            <i className="fa fa-clock text-grey-darker pr-2" />
            <span
              className={`font-heading text-sm  ${
                "text-grey-darker"
              } font-bold mr-3 xl:mr-2 xxl:mr-3`}
            >
                    {evd.venue.name}
                  </span>
          </div>
        })}
      </div> : null
      }

    </div>
  )
}
const mapStateToProps = state => {
  return {
    isCompany: isCompanyUser(state.auth) || isCompanyAdmin(state.auth),
  };
};

export default connect(mapStateToProps, null)(VenuesToExport);
